import { env } from "@/env";

export const SUBSCRIPTION_STATUS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  HAS_RECOMMENDATIONS: "HAS_RECOMMENDATIONS",
  NO_SUBSCRIPTION: "NO_SUBSCRIPTION",
  CANCELLED: "CANCELLED",
  EXPIRED: "EXPIRED",
  PAUSED: "PAUSED",
  PENDING: "PENDING",
} as const;

export const SUBSCRIPTION_ACTION = {
  RESUME: "resume",
  PAUSE: "pause",
  CANCEL: "cancel",
  REACTIVATE: "reactivate",
} as const;

export const DEFAULT_SUBSCRIPTION_PROCESSING_TIMEOUT_MS = 30_000;

const subscriptionProcessingTimeoutSeconds = Number(
  env.VITE_SUBSCRIPTION_PROCESSING_TIMEOUT_SECONDS,
);

export const SUBSCRIPTION_PROCESSING_TIMEOUT_MS =
  Number.isFinite(subscriptionProcessingTimeoutSeconds) && subscriptionProcessingTimeoutSeconds > 0
    ? subscriptionProcessingTimeoutSeconds * 1000
    : DEFAULT_SUBSCRIPTION_PROCESSING_TIMEOUT_MS;
